import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
        }),
        async saveForm(event) {
            try {
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'afiliacionFtn':
                            await this.updateDataPost({ state: 'tablaPost', data: ['info_ingresos', 'datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'afiliado_beneficiarios'] })
                            break;

                        case 'guardarFtn':
                            // resetea servicios nuevos y asigna los check de dataMultiple a servicios_nuevos y asigno servicios_Activos
                            let totalAfl = 0
                            let await01 = this.resetDataForm({ state: 'servicios_nuevos' })
                            let await02 = this.resetDataForm({ state: 'servicios_activos' })

                            await Promise.all([await01, await02])

                            let awaitfor = []

                            for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                                if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1 && this.dataMultiple[this.namePath].multiple_servicios[i].disabled === 0) {
                                    let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                                    newValue.id = null
                                    totalAfl = totalAfl + this.dataMultiple[this.namePath].multiple_servicios[i].afiliacion
                                    awaitfor.push(this.pushDataForm({ state: 'servicios_nuevos', data: newValue }))
                                }
                                if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1 && this.dataMultiple[this.namePath].multiple_servicios[i].disabled === 1) {
                                    totalAfl = totalAfl + this.dataMultiple[this.namePath].multiple_servicios[i].afiliacion
                                    let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                                    newValue.id = null
                                    newValue.mes_periodo = this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.mes
                                    newValue.ano_periodo = this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.ano
                                    awaitfor.push(await this.pushDataForm({ state: 'servicios_activos', data: newValue }))
                                }
                            }

                            await Promise.all(awaitfor)

                            // se actualizan datos de info_Afiliacion y afiliacion_registro
                            const await1 = this.updateDataForm({ state: 'info_afiliacion/id_list_users', data: this.user.id })
                            const await2 = this.updateDataForm({ state: 'info_afiliacion/fecha', data: this.fecha().fecha.minHoy })
                            const await3 = this.updateDataForm({ state: 'afiliacion_registro/fecha', data: this.fecha().fecha.minHoy })

                            const await4 = this.updateDataForm({ state: 'afiliacion_registro/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon })
                            const await5 = this.updateDataForm({ state: 'afiliacion_registro/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor })
                            const await6 = this.updateDataForm({ state: 'afiliacion_registro/valor', data: totalAfl })
                            const await7 = this.updateDataForm({ state: 'afiliacion_registro/servicios', data: this.dataForm[this.namePath].servicios_nuevos })
                            const await8 = this.updateDataForm({ state: 'info_afiliacion/salariobase', data: this.dataForm[this.namePath].info_afiliacion.salario })

                            var name = this.dataForm[this.namePath].datos_afiliado.nombre1 + ' ' + this.dataForm[this.namePath].datos_afiliado.nombre2 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido1 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido2
                            var re = /null/gi;

                            const await9 = this.updateDataForm({ state: 'datos_afiliado/name', data: name.replace(re, ' ') })
                            const await10 = this.updateDataForm({ state: 'datos_afiliado/id_list_estado', data: 1 })

                            // se configura el dataPost
                            const await11 = this.updateDataPost({ state: 'route', data: 'save_all' })
                            const await12 = this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'afiliado_beneficiarios'] })
                            const await13 = this.updateDataPost({ state: 'tablaDelete', data: [] })

                            await Promise.all([await1, await2, await3, await4, await5, await6, await7, await8, await9, await10, await11, await12, await13])

                            if (event.save === false) {
                                await this.updateDataPost({ state: 'data', data: [] })
                            }

                            // se abre el modal de afiliacion si se esta guardando
                            if (event.save === false && this.dataIndex[this.namePath] === false) {
                                await this.updateGlobal({
                                    state: 'openModal/modal',
                                    data: { value: true, title: 'Registrar Afiliación', modal: 'Afiliacion', loaded: false, size: 'md' }
                                })

                                return true
                            }
                            break;
                    }
                }

                let dataSave = await this.save(event.save, event.savePost)

                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'guardarFtn':
                            if (event.save === true) {
                                const await12 = this.saveNotify(false, 'Agrupado con éxito', false, false)
                                const await13 = this.updateDataForm({ state: 'servicios_activos', data: [] })
                                const await14 = this.updateDataForm({ state: 'servicios_nuevos', data: [] })
                                const await15 = this.resetDataForm({ state: 'datos_afiliado' })
                                const await16 = this.updateDataForm({ state: 'info_afiliacion/observacion', data: null })
                                await await12
                                await await13
                                await await14
                                await await15
                                await await16
                            } else {
                                const await16 = this.resetDataForm()
                                const await17 = this.onInit()
                                await await16
                                await await17
                            }
                            break;
                        case 'afiliacionFtn':
                            window.open(this.url + '/api/pdf/ficha?id=' + dataSave.ids.datos_afiliado.toString() + '&token=' + this.token, '_blank')
                            window.open(this.url + '/api/pdf/registro?id=' + dataSave.ids.info_ingresos.toString() + '&token=' + this.token, '_blank')
                            const await18 = this.resetDataForm()
                            const await19 = this.onInit()
                            await await18
                            await await19
                            break;
                        case 'afiliacionGrupalFtn':
                            window.open(this.url + '/api/pdf/ficha?id=' + dataSave.ids.datos_afiliado.toString() + '&token=' + this.token, '_blank')
                            window.open(this.url + '/api/pdf/registro?id=' + dataSave.ids.info_ingresos.toString() + '&token=' + this.token, '_blank')
                            const await24 = this.resetDataForm()
                            const await25 = this.onInit()
                            await await24
                            await await25
                            break;
                    }
                }

                const await20 = this.resetDataIndex()
                const await21 = this.resetGlobal({ state: 'openModal' })
                const await22 = this.updateCrud({ state: 'dataMultiple/' + this.namePath + '/multiple_servicios', data: this.predeterminados[this.namePath].multiple_servicios })
                const await23 = this.resetGlobal({ state: 'saveConfig/capa' })
                const await24 = this.resetGlobal({ state: 'saveConfig/saveloading' })
                const awaitAll = await Promise.all([await20, await21, await22, await23, await24])
                if (!event.save) {
                    await this.resetDataPost({ state: 'data' })
                }

                return true

            } catch {

            }
        }
    },
}